import { UploadFileBean } from "./upload-file-bean";

export class UploadMutlipleFileRequest {
  docReference: string;
  docType: string;
  referenceKeys: string[];
  userId: string;
  remark: string | null;
  fileBeans: UploadFileBean[] | null;

  constructor() {
    this.docReference = "";
    this.docType = "";
    this.referenceKeys = [];
    this.userId = "";
    this.remark = null;
    this.fileBeans = [];
  }
}
